export interface TQueryKey<TKey, TListQuery = any, TDetailQuery = string> {
	all: readonly [TKey]
	lists: () => readonly [...TQueryKey<TKey>['all'], 'list']
	list: (query?: TListQuery) => readonly [...ReturnType<TQueryKey<TKey>['lists']>, { query: TListQuery }]
	details: () => readonly [...TQueryKey<TKey>['all'], 'detail']
	detail: (
		id: TDetailQuery,
		query?: TListQuery,
	) => readonly [...ReturnType<TQueryKey<TKey>['details']>, TDetailQuery, { query: TListQuery }]
}

export const useQueryKeyFactory = <T, TListQueryType = any, TDetailQueryType = string>(globalKey: T) => {
	const queryKeyFactory: TQueryKey<T, TListQueryType, TDetailQueryType> = {
		all: [globalKey],
		lists: () => [...queryKeyFactory.all, 'list'],
		// @ts-ignore ...
		list: (query?: TListQueryType) =>
			[...queryKeyFactory.lists(), query ? { query } : undefined].filter(k => Boolean(k)),
		details: () => [...queryKeyFactory.all, 'detail'],
		// @ts-ignore ...
		detail: (id: TDetailQueryType, query?: TListQueryType) =>
			[...queryKeyFactory.details(), id, query ? { query } : undefined].filter(k => Boolean(k)),
	}
	return queryKeyFactory
}
